import Vue from 'vue';

const modulePrefix = 'countries/';

const COUNTRIES_SET = modulePrefix + 'set';

export const COUNTRIES_GET = modulePrefix + 'get';
const COUNTRIES_GET_REQUEST = modulePrefix + 'get_request';
const COUNTRIES_GET_SUCCESS = modulePrefix + 'get_success';
const COUNTRIES_GET_ERROR = modulePrefix + 'get_error';

export const COUNTRIES_CLEAR = modulePrefix + 'clear';

// countries = [{
//     id: 7,
//     code: 'BE',
//     number: null,
//     name: 'Belgie',
//     lat: '50.819818',
//     lng: '4.334106',
//     seo_url: 'belgie',
//     created: '05-03-2008 07:58',
//     created_by: 2,
//     modified: '',
//     modified_by: null,
//     has_sales: true,
// }];

export default {
    state: {
        countries: [],
        loading: false,
        errors: [],
        promise: null,
    },
    mutations: {
        [COUNTRIES_SET](state, countries) {
            state.countries = countries;
        },
        [COUNTRIES_GET_REQUEST](state, promise) {
            state.loading = true;
            state.errors = [];
            state.promise = promise;
        },
        [COUNTRIES_GET_SUCCESS](state) {
            state.loading = false;
            state.errors = [];
        },
        [COUNTRIES_GET_ERROR](state, errors) {
            state.loading = false;
            state.errors = errors;
            state.promise = null;
        },
    },
    actions: {
        // Get the list of countries
        [COUNTRIES_GET]({commit, state}) {
            if (state.loading || state.countries.length) return state.promise;
            const promise = Vue.axios
                .get('autogen/api/countries')
                .then(response => {
                    commit(COUNTRIES_SET, response.data);
                    commit(COUNTRIES_GET_SUCCESS);
                })
                .catch(({status, errors}) => {
                    commit(COUNTRIES_GET_ERROR, errors);
                    throw {status, errors};
                });
            commit(COUNTRIES_GET_REQUEST, promise);
            return promise;
        },
        // Empties the list of countries, so the next COUNTRIES_GET action will re-request the data
        [COUNTRIES_CLEAR]({commit}) {
            commit(COUNTRIES_SET, []);
        },
    },
    getters: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/countries.js